export { default } from "./DoctorAvailability.gql";
